import i18n from '@/api/i18n/i18n';

export const CHILDREN_DASHBORD = [
  { id: 1, name: i18n.t('computers.reports.workTime'), field: 'workTime', color: '#009999' },
  { id: 2, name: i18n.t('computers.reports.activeTime'), field: 'activeTime', color: '#33CCCC' },
  { id: 3, name: i18n.t('computers.reports.web'), field: 'web', color: '#6C8DD5' },
  { id: 4, name: i18n.t('computers.reports.productiveWeb'), field: 'productiveWeb', color: '#6A48D7' },
  {
    id: 5,
    name: i18n.t('computers.reports.unProductiveWeb'),
    field: 'unProductiveWeb',
    color: '#9F3ED5',
  },
  { id: 6, name: i18n.t('computers.reports.productivePC'), field: 'productivePC', color: '#AD66D5' },
  { id: 7, name: i18n.t('computers.reports.unProductivePC'), field: 'unProductivePC', color: '#FF7400' },
  { id: 8, name: i18n.t('computers.reports.printer'), field: 'printer', color: '#FFFF00' },
  { id: 9, name: i18n.t('computers.reports.overtimeUndertime'), field: 'overwork', color: '#66ff00' },
];

export const REPORT_IDS_SUMMARY = CHILDREN_DASHBORD.filter(({ id }) => ![4, 5].includes(id)).map(({ id }) => id);
